export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x0000000000000000000000000000000000000000",
  eulerSwapV1Implementation: "0x0000000000000000000000000000000000000000",
  eulerSwapV1Periphery: "0x0000000000000000000000000000000000000000",
  eulerSwapV2Factory: "0xFbF2a49CB0cc50F4ccd4eAc826eF1A76D99D29Eb",
  eulerSwapV2Implementation: "0xC00F0B7d7B4F7cA3d3f79f3892069f41C142dB84",
  eulerSwapV2Periphery: "0x61aFC386b47a11F8721b67Eb1607cFBd9ccE48B1",
  eulerSwapV2ProtocolFeeConfig: "0x434b1072d96ea24967CDe289D3d4d81d2BAD4F30",
  eulerSwapV2Registry: "0x7E1Efb6A2009A1FDaDee1c5d6615260AD70c14Fb",
} as const
